// extracted by mini-css-extract-plugin
module.exports = {"social":"SocialLinks_social__5_e03","socialLink":"SocialLinks_socialLink__Wep9r"};